module.exports = __webpack_public_path__ + "static/media/chorus-line-2.5f8b1a79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facts/chorus-line-2.jpg
// module id = 127
// module chunks = 0